module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.getters['player/isPlaying']) ? _c('v-layout', {
    staticClass: "bottom-player",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "track-detail-section",
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "track-cover-container"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.item.album_type) + "/" + (_vm.item.slug))
    }
  }, [(_vm.item.album_type == 'playlist') ? [_c('div', {
    staticClass: "track-cover-image",
    class: _vm.item.album_type,
    style: ({
      'background-image': ("url(" + _vm.album1Cover + "), url(" + _vm.album2Cover + "), url(" + _vm.album3Cover + "), url(" + _vm.album4Cover + ")"),
    })
  })] : [_c('div', {
    staticClass: "track-cover-image",
    style: ({
      'background-image': 'url(' + _vm.item.cover.url + ')'
    })
  })]], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "track-info-container"
  }, [_c('div', [_c('div', {
    staticClass: "track-info"
  }, [_c('label', {
    staticClass: "track-index",
    attrs: {
      "id": "trackIndex"
    }
  }, [_vm._v(_vm._s(_vm.trackIndex))]), _vm._v(" "), _c('label', {
    staticClass: "track-name",
    attrs: {
      "id": "trackName"
    }
  }, [_vm._v(_vm._s(_vm.track.name))])]), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [(_vm.item.collaborators_count > 0) ? [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": '/' + _vm.item.user.slug
    }
  }, [_vm._v(_vm._s(_vm.item.user.username))]), _vm._v(" "), _vm._l((_vm.item.collaborators), function(c) {
    return [_c('span', {
      key: ("span-" + (c.user.id))
    }, [_vm._v(", ")]), _vm._v(" "), _c('router-link', {
      key: ("link-" + (c.user.id)),
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (c.user.slug))
      }
    }, [_vm._v(_vm._s(c.user.username))])]
  })] : (_vm.item.album_type == 'album') ? [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": '/' + _vm.item.user.slug
    }
  }, [_vm._v(_vm._s(_vm.item.user.username))]), _vm._v(" "), (_vm.currentUser && _vm.item.user.id != _vm.currentUser.id) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.item,
      "theme": "dark",
      "type": "player"
    }
  }) : _vm._e()] : [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": '/' + _vm.track.user.slug
    }
  }, [_vm._v(_vm._s(_vm.track.user.username))]), _vm._v(" "), (_vm.currentUser && _vm.track.user.id != _vm.currentUser.id) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.track,
      "theme": "dark",
      "type": "player"
    }
  }) : _vm._e()]], 2)])])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [(!_vm.isLoaded) ? _c('div', {
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoaded) ? _c('div', {
    staticClass: "player-section"
  }, [_c('div', {
    staticClass: "controls-section"
  }, [_c('div', {
    staticClass: "volume-container"
  }, [_c('div', {
    staticClass: "volume"
  }, [_c('v-slider', {
    staticClass: "volume-ranger",
    attrs: {
      "thumb-label": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.updateVolume
    },
    model: {
      value: (_vm.volume),
      callback: function($$v) {
        _vm.volume = $$v
      },
      expression: "volume"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/ic_sound.svg",
      "width": "20"
    }
  })], 1)]), _vm._v(" "), _c('v-btn', {
    staticClass: "player-control-btn",
    nativeOn: {
      "click": function($event) {
        _vm.skip('prev')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_rewind.svg",
      "width": "20"
    }
  })]), _vm._v(" "), (!_vm.isPlaying) ? _c('v-btn', {
    staticClass: "player-control-btn play",
    attrs: {
      "id": "play"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$root.$emit(_vm.MyEvents.AUDIO_PLAYER_REPLAY)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_play.svg",
      "height": "26"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isPlaying) ? _c('v-btn', {
    staticClass: "player-control-btn pause",
    attrs: {
      "id": "pause"
    },
    nativeOn: {
      "click": function($event) {
        _vm.pause()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_pause.svg",
      "height": "26"
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "player-control-btn",
    nativeOn: {
      "click": function($event) {
        _vm.skip('next')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_skip.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('v-btn', {
    staticClass: "player-control-btn",
    class: {
      selected: _vm.isRepeated
    },
    nativeOn: {
      "click": function($event) {
        _vm.setRepeated()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_refresh.svg",
      "width": "18"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "bar-section"
  }, [_c('label', {
    staticClass: "duration-time played",
    attrs: {
      "id": "playedTime"
    }
  }, [_vm._v(_vm._s(_vm.playedTime))]), _vm._v(" "), _c('v-spacer', [_c('v-slider', {
    staticClass: "player-bar",
    attrs: {
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.seek(_vm.progress)
      }
    },
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "duration-time total",
    attrs: {
      "id": "totalTime"
    }
  }, [_vm._v(_vm._s(_vm.totalTime))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showReminder) ? _c('div', {
    staticClass: "reminder-section"
  }, [_c('div', {
    staticClass: "media d-flex"
  }, [_c('div', {
    staticClass: "media__image"
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v("Reminder!")]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n            Support your favorite artists & brands\n          ")])])])]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    staticClass: "actions-section",
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": "",
      "text-xs-right": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "slot": "activator"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showShareModal = true
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_share.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Share")])], 1), _vm._v(" "), (_vm.stripeConnected) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "slot": "activator"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDownloadModal = true
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_download.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Download")])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "slot": "activator"
    },
    nativeOn: {
      "click": function($event) {
        _vm.repostItem()
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_repost.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Repost")])], 1), _vm._v(" "), (_vm.showDownloadModal) ? _c('download-modal', {
    attrs: {
      "item": _vm.item,
      "track": _vm.track,
      "dismiss": _vm.dismissDownloadDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShareModal) ? _c('share-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.dismissShareDialog
    }
  }) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0fb3680","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/player.vue
// module id = 1852
// module chunks = 180